module.exports = __webpack_public_path__ + "static/media/page_13.e5a67fdd.jpg";